import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Observable, Subject } from "rxjs";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { validarRut, VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { ClienteInternacional } from "src/app/models/ClienteInternacional/ClienteInternacional";
import { Pais } from "src/app/models/Dte/Exportacion/Pais";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { Proveedor } from "src/app/models/Proveedor/Proveedor";
import { Receptor } from "src/app/models/Receptor/Receptor";
import { cambiaronDatosReceptor, esRutGenerico } from "src/app/models/Receptor/receptor-personalizacion";
import { ResultadoImportacion } from "src/app/models/ResultadoImportacion";
import { ClienteInternacionalService } from "src/app/services/cliente-internacional.service";
import { ClienteService } from "src/app/services/cliente.service";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { SubheaderService } from "src/app/_metronic/partials/layout";
import Swal from "sweetalert2";
import { ProveedorService } from "src/app/services/proveedor.service";
import { finalize, takeUntil } from "rxjs/operators";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { formatToRut } from "src/app/directives/formatToRut.directive";
import { SiiSearchService } from "src/app/services/sii-search.service";

@Component({
	selector: "app-buscador-cliente",
	templateUrl: "./buscador-cliente.component.html",
	styleUrls: ["./buscador-cliente.component.scss"],
})
export class BuscadorClienteComponent implements OnInit, OnChanges {
	@ViewChild("currentSwal") public currentSwal: SwalComponent;
	@ViewChild("swalBuscandoCliente") public swalBuscandoCliente: SwalComponent;
	@ViewChild("clientListModal") private clientListTemplate: any;

	public currentClient: Receptor = new Receptor();
	public currentProv: Proveedor = new Proveedor();
	public clientObservable: Observable<Receptor>;
	public contraparteGroupForm: FormGroup;
	public proveedorGroupForm: FormGroup;
	@Output() private clientForInvoice: EventEmitter<Receptor> = new EventEmitter<Receptor>();
	@Output() private proveedorForInvoice: EventEmitter<Proveedor> = new EventEmitter<Proveedor>();
	@Output()
	private clienteInternacionalFOrInvoice: EventEmitter<ClienteInternacional> = new EventEmitter<ClienteInternacional>();
	@Input() public fromExistente: DteEmitido;
	public loadingClient$: Observable<boolean>;
	public resetingDte$: Observable<boolean>;
	private clientListModal: NgbModalRef;
	private proveedorListModalRef: NgbModalRef;
	private emisorId = this.tokenStorage.getCompany();
	private searchingSubelement: boolean = false;
	private prevSearch: string;
	private invoiceType$: Observable<InvoiceType>;
	public isFacturaCompra: boolean = null;
	public editableFormControl: boolean = false;
	public editableFromSII: boolean = false;
	public validateRut: boolean = true;
	public isFacturaExportacion: boolean = null;
	public isLiquidacion: boolean = false;
	private internationalClientModalRef: NgbModalRef;
	public currentInternationalClient: ClienteInternacional;
	private PaisesSource: Pais[] = [];
	public loggedInUserEmail: string; // Correo del usuario logueado
	public showEmailWarning: boolean = false;
	public resultadosClientes: Receptor[];
	public tieneVersionPropia = false;
	private receptorOriginal: Partial<Receptor> = {};

	constructor(private facturador: FacturacionIndividualService, private ref: ChangeDetectorRef, private builder: FormBuilder, private modalService: NgbModal, private tokenStorage: TokenStorageService, private localStorage: LocalStorageService, private clientService: ClienteService, private proveedorService: ProveedorService, private internationalClientService: ClienteInternacionalService, private subheader: SubheaderService, private siiSearchService: SiiSearchService) {
		this.setClientForm();
		this.loadingClient$ = this.facturador.isLoadingClientObservable;
		this.resetingDte$ = this.facturador.submittedDteObservable;
		this.invoiceType$ = this.facturador.currentInvoiceTypeObservable;
		this.PaisesSource = this.localStorage.getPaises();
	}

	ngOnInit(): void {
		this.loggedInUserEmail = this.tokenStorage.getUser().email;
		this.currentClient = new Receptor();
		this.facturador.selectedClientObservable.pipe(takeUntil(this.destroy$)).subscribe((client) => this.applySelectedClientFromService(client));
		this.facturador.selectedProveedorObservable.pipe(takeUntil(this.destroy$)).subscribe((proveedor) => this.applySelectedProveedorFromService(proveedor));
		const resetDteSubscription = this.resetingDte$.subscribe((res) => {
			if (res) {
				this.currentClient = new Receptor();
				this.toggleCorreoFactControl();
			}
		});
		this.invoiceType$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
			this.isFacturaCompra = res == InvoiceType.FacturaCompra;
			this.isFacturaExportacion = res == InvoiceType.FacturaExportacion;
			this.isLiquidacion = res == InvoiceType.LiquidacionFactura;
			this.validateRut = !this.isFacturaExportacion;
			if (this.validateRut) this.contraparteGroupForm.get("rutBusqueda").setValidators([VerificacionRutValidator]);
			this.editableFormControl = this.isFacturaCompra;

			// if (!this.isFacturaCompra) {
			// 	this.contraparteGroupForm.get("comuna").disable();
			// 	this.contraparteGroupForm.get("ciudad").disable();
			// 	this.contraparteGroupForm.get("giro").disable();
			// }
			if (res == InvoiceType.FacturaExportacion) {
				this.validateRut = false;
				this.deactivateValidator(this.contraparteGroupForm, "rutBusqueda");
				this.isFacturaExportacion = true;
			}
			if (res == InvoiceType.LiquidacionFactura) {
				this.isLiquidacion = true;
			}
			this.toggleCorreoFactControl();
			this.ref.detectChanges();
		});

	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["fromExistente"] && changes["fromExistente"].currentValue) {
			const dteExistente = changes["fromExistente"].currentValue as DteEmitido;
			this.currentClient = { ...dteExistente.receptorEnt, clienteId: dteExistente.clienteId || dteExistente.receptorEnt?.clienteId };
			this.receptorOriginal = { ...this.currentClient };
			this.refreshForm(this.currentClient, this.contraparteGroupForm);
			this.contraparteGroupForm.get("rutBusqueda").patchValue(this.currentClient.rutString);
			this.toggleCorreoFactControl();
			this.ref.detectChanges();
			this.clientForInvoice.emit(this.currentClient);
		}
	}

	private destroy$ = new Subject<void>();
	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private applySelectedClientFromService(client: Receptor | null): void {
		if (this.isFacturaCompra) {
			if (!client && !this.currentProv?.rutProveedor) {
				this.reset();
				this.ref.detectChanges();
			}
			return;
		}
		if (!client) {
			this.reset();
			this.ref.detectChanges();
			return;
		}
		this.currentClient = { ...client } as Receptor;
		this.receptorOriginal = { ...client };
		if (this.isFacturaExportacion && (client as any).clienteInternacionalId) {
			this.currentInternationalClient = {
				clienteInternacionalId: (client as any).clienteInternacionalId,
				razonSocial: client.razonSocial,
				giro: client.giro,
				direccionCalle: client.dirFact?.split(' ')[0] || '',
				direccionNumero: client.dirFact?.split(' ')[1] || '',
				direccionEstadoRegion: client.comuna,
				ciudad: client.ciudad,
				correo: client.correoFact,
				nombrePais: (client as any).nombrePais,
				paisId: (client as any).paisId,
				codigoPais: (client as any).codigoPais
			} as any;
		}
		
		this.refreshForm(this.currentClient, this.contraparteGroupForm);
		
		if (this.isFacturaExportacion && (client as any).nombrePais) {
			this.contraparteGroupForm.controls.pais.patchValue((client as any).nombrePais);
		}
		
		if (this.currentClient?.rutString) {
			this.contraparteGroupForm.get("rutBusqueda")?.patchValue(this.currentClient.rutString, { emitEvent: false });
		}
		this.prevSearch = undefined;
		this.ref.detectChanges();
	}

	private applySelectedProveedorFromService(proveedor: Proveedor | null): void {
		if (!this.isFacturaCompra) {
			return;
		}
		if (!proveedor) {
			this.currentProv = new Proveedor();
			this.refreshForm(this.currentProv, this.contraparteGroupForm);
			this.contraparteGroupForm.get("rutBusqueda")?.patchValue("", { emitEvent: false });
			this.prevSearch = undefined;
			this.ref.detectChanges();
			return;
		}
		this.currentProv = { ...proveedor } as Proveedor;
		this.refreshForm(this.currentProv, this.contraparteGroupForm);
		if (this.currentProv?.rutProveedor) {
			this.contraparteGroupForm.get("rutBusqueda")?.patchValue(this.currentProv.rutProveedor, { emitEvent: false });
		}
		this.prevSearch = undefined;
		this.ref.detectChanges();
	}

	buscaCliente(rut: string) {
		if (this.searchingSubelement || this.prevSearch == rut) {
			return;
		} else {
			if (rut != null && rut != "" && !this.searchingSubelement && validarRut(rut)) {
				this.currentClient.rutString = formatToRut(rut);
				this.contraparteGroupForm.get("rutBusqueda").patchValue(this.currentClient.rutString);
				this.prevSearch = rut;
			}
			if (rut != null && rut != "" && this.contraparteGroupForm.valid && !this.searchingSubelement && rut.length > 7) {
				this.searchingSubelement = true;
				this.prevSearch = rut;
				if (this.isFacturaCompra && this.isWildcardRut(rut)) {
					this.currentProv = new Proveedor();
					this.currentProv.rutProveedor = formatToRut(rut);
					this.refreshForm(this.currentProv, this.contraparteGroupForm);
					this.proveedorForInvoice.emit(this.currentProv);
					this.facturador.updateProveedor(this.currentProv.rutProveedor, this.currentProv);
					this.searchingSubelement = false;
					this.ref.detectChanges();
					return;
				}
				if (this.isFacturaCompra) {
					this.facturador.searchProveedor(rut, this.emisorId).subscribe(
						(result) => {
							this.ref.detectChanges();
							if (result.data.length == 0) {
								const cancelSubject = this.siiSearchService.showSearchModal("Buscando en el SII", "El proveedor no está ingresado. Estamos buscando su información en el SII. Esto puede tardar unos segundos");

								this.proveedorService
									.getFromSii(rut, this.emisorId)
									.pipe(takeUntil(cancelSubject))
									.subscribe(
										(data) => {
											this.siiSearchService.closeSearchModal();
											if (data.status == 200) {
												let newProv = data.data[0] as Proveedor;
												this.currentProv = { ...newProv };
												this.refreshForm(this.currentProv, this.contraparteGroupForm);
												this.refreshFormValue("rut", rut);
												this.proveedorForInvoice.emit(this.currentProv);
												this.facturador.updateProveedor(this.currentProv.rutProveedor, this.currentProv);
												this.setSubheaderClientTitle(this.currentProv as Proveedor);
												this.searchingSubelement = false;
												this.editableFromSII = null;
												this.ref.detectChanges();
											} else {
												this.currentSwal.text = "No fue posible obtener información del SII para este RUT";
												this.currentSwal.fire();
												this.searchingSubelement = false;
											}
										},
										(error) => {
											this.siiSearchService.closeSearchModal();
											this.searchingSubelement = false;
											this.prevSearch = undefined;
											this.currentProv = new Proveedor();
											this.currentProv.rutProveedor = rut;
											this.proveedorForInvoice.emit(this.currentProv);
											this.facturador.updateProveedor(this.currentProv.rutProveedor, this.currentProv);
											this.refreshForm(this.currentProv, this.contraparteGroupForm);
											this.refreshFormValue("razonSocial", "");
											this.ref.detectChanges();
											Swal.fire({
												text: "El RUT " + rut + " no tiene registros en el SII. Se debe agregar manualmente",
												title: "Sin datos en el SII",
												showConfirmButton: true,
												allowOutsideClick: false,
												allowEscapeKey: false,
												showDenyButton: false,
											});
										}
									);
							} else if (result.data[0]) {
								let newProv = result.data[0] as Proveedor;
								this.currentProv = { ...newProv };
								if (this.needsDataFromSii(this.currentProv)) {
									let cancelSubject = new Subject<void>();
									Swal.fire({
										iconHtml: '<img src="./assets/deployAssets/icons/loader_16x16.gif">',
										title: "Buscando en el SII",
										showConfirmButton: false,
										showCancelButton: true,
										cancelButtonText: "Cancelar",
										cancelButtonColor: "red",
										allowOutsideClick: false,
										allowEscapeKey: false,
										showDenyButton: false,
										text: "El proveedor no está actualizado. Estamos buscando su información en el SII. Esto puede tardar unos segundos",
									}).then((result) => {
										if (result.isDismissed && String(result.dismiss) === "cancel") {
											cancelSubject.next();
										}
										cancelSubject.complete();
									});
									setTimeout(() => {
										if (Swal.isVisible()) {
											Swal.update({
												title: "Buscando en el SII",
												text: "La búsqueda está tomando más tiempo de lo esperado. Es posible que el SII tenga alguna sobrecarga. Unos segundos más por favor",
											});
										}
									}, 30 * 1000);
									this.proveedorService
										.getFromSii(rut, this.emisorId)
										.pipe(takeUntil(cancelSubject))
										.subscribe(
											(sii) => {
												Swal.close();
												cancelSubject.complete();
												if (sii.status == 200) {
													const provSii: any = sii.data[0] ? sii.data[0] : sii.data;
													this.currentProv = { ...this.currentProv, ...provSii };
													this.currentProv.emisorId = this.emisorId;
													this.proveedorService.actualizarProveedor(this.currentProv).subscribe();
												}
												this.contraparteGroupForm.controls.correoFact.patchValue(this.currentProv.correoFact);
												this.refreshForm(this.currentProv, this.contraparteGroupForm);
												this.refreshFormValue("rut", rut);
												this.proveedorForInvoice.emit(this.currentProv);
												this.setSubheaderClientTitle(this.currentProv as Proveedor);
												this.searchingSubelement = false;
												this.ref.detectChanges();
											},
											() => {
												Swal.close();
												cancelSubject.complete();
												this.contraparteGroupForm.controls.correoFact.patchValue(this.currentProv.correoFact);
												this.refreshForm(this.currentProv, this.contraparteGroupForm);
												this.refreshFormValue("rut", rut);
												this.proveedorForInvoice.emit(this.currentProv);
												this.setSubheaderClientTitle(this.currentProv as Proveedor);
												this.searchingSubelement = false;
												this.ref.detectChanges();
											}
										);
								} else {
									this.contraparteGroupForm.controls.correoFact.patchValue(this.currentProv.correoFact);
									this.refreshForm(this.currentProv, this.contraparteGroupForm);
									this.refreshFormValue("rut", rut);
									this.proveedorForInvoice.emit(this.currentProv);
									this.setSubheaderClientTitle(this.currentProv as Proveedor);
									this.searchingSubelement = false;
									this.ref.detectChanges();
								}
							}
						},
						(error) => {
							this.searchingSubelement = false;
							this.prevSearch = undefined;
						}
					);
				} else {
					this.buscarReceptores(rut);
				}
			}
		}
	}

	private buscarReceptores(rut: string): void {
		this.tieneVersionPropia = false;
		this.selectedReceptor({ rutString: formatToRut(rut) } as Receptor);
		this.facturador.searchClient(rut, this.emisorId).pipe(takeUntil(this.destroy$)).subscribe({
			next: result => {
				const clientes = result.data || [];
				this.tieneVersionPropia = clientes.some(cliente => !!cliente.clienteId);
				this.searchingSubelement = false;
				if (clientes.length > 1) {
					this.resultadosClientes = clientes;
					this.mostrarSelectorClientes();
				} else if (clientes.length === 1) {
					this.selectedReceptor(clientes[0]);
					if (!clientes[0].tieneDatosPropios && !esRutGenerico(rut) && this.needsDataFromSii(clientes[0])) this.cargarClienteSii(rut);
				} else if (!esRutGenerico(rut)) {
					this.cargarClienteSii(rut);
				}
				this.ref.detectChanges();
			},
			error: () => {
				this.searchingSubelement = false;
				this.prevSearch = undefined;
				this.currentSwal.text = "No fue posible buscar el cliente. Intente nuevamente.";
				this.currentSwal.fire();
			},
		});
	}

	private cargarClienteSii(rut: string): void {
		this.searchingSubelement = true;
		const cancelacion = this.siiSearchService.showSearchModal("Buscando en el SII", "Buscando información del cliente. Esto puede tardar unos segundos.");
		this.clientService.getFromSii(rut, this.emisorId).pipe(
			takeUntil(cancelacion),
			takeUntil(this.destroy$),
			finalize(() => {
				this.searchingSubelement = false;
				this.ref.detectChanges();
			}),
		).subscribe({
			next: result => {
				this.siiSearchService.closeSearchModal();
				if (result.status === 200 && result.data) this.selectedReceptor(result.data);
			},
			error: () => {
				this.siiSearchService.closeSearchModal();
				this.siiSearchService.showNoDataMessage("El RUT " + rut + " no tiene registros en el SII. Complete los datos manualmente.");
			},
		});
	}

	private needsDataFromSii(ent: { giro?: string; dirFact?: string; comuna?: string; ciudad?: string }): boolean {
		const placeholders: Record<"giro" | "dirFact" | "comuna" | "ciudad", readonly string[]> = {
			giro: ["sin giro"] as const,
			dirFact: ["sin direccion", "sin dirección", "s/d", "sn", "s/n", "n/a"] as const,
			comuna: ["sin comuna"] as const,
			ciudad: ["sin ciudad"] as const,
		};

		const keys: (keyof typeof placeholders)[] = ["giro", "dirFact", "comuna", "ciudad"];
		return keys.some((k) => this.isPlaceholderOrEmpty(ent[k], placeholders[k]));
	}

	private isPlaceholderOrEmpty(value: string | undefined, placeholders: ReadonlyArray<string> = []): boolean {
		const v = this.normalize(value);
		if (!v) return true; // null/undefined/"" -> vacío
		// comparamos contra placeholders normalizados
		for (const p of placeholders) {
			if (this.normalize(p) === v) return true;
		}
		return false;
	}

	private normalize(s?: string): string {
		return (s ?? "")
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "") // quita tildes (más compatible que \p{Diacritic})
			.trim();
	}

	private isWildcardRut(rut: string): boolean {
		return esRutGenerico(rut);
	}

	searchClientAlternIdentifier(identifier: string) {
		//search for foreign client identifier different from Chile
		this.currentClient.rutString = identifier;
		this.searchingSubelement = true;
		this.internationalClientService.searchClient(identifier, this.emisorId).subscribe(
			(result) => {
				let newClient = result.data[0] as ClienteInternacional;
				this.currentInternationalClient = { ...newClient };
				this.ref.detectChanges();
				let client: Receptor = new Receptor();
				client.razonSocial = this.currentInternationalClient.razonSocial;
				client.giro = this.currentInternationalClient.giro;
				client.dirFact = this.currentInternationalClient.direccionCalle + " " + this.currentInternationalClient.direccionNumero;
				client.comuna = this.currentInternationalClient.direccionEstadoRegion;
				client.ciudad = this.currentInternationalClient.ciudad;
				client.correoFact = this.currentInternationalClient.correo;
				client.rutString = this.currentInternationalClient.clienteInternacionalId.toString();
				this.currentInternationalClient.nombrePais = this.PaisesSource.find((pais) => pais.paisId == this.currentInternationalClient.paisId).nombre;
				this.refreshForm(client, this.contraparteGroupForm);
				// this.refreshFormValue("rutBusqueda",client.rutString);
				this.refreshFormValue("razonSocial", client.razonSocial);
				this.refreshFormValue("giro", client.giro);
				this.refreshFormValue("dirFact", client.dirFact);
				this.refreshFormValue("comuna", client.comuna);
				this.refreshFormValue("ciudad", client.ciudad);
				this.refreshFormValue("correoPar", client.correoPar);
				this.refreshFormValue("correoFact", client.correoFact);
				this.refreshFormValue("pais", this.currentInternationalClient.nombrePais);
				this.contraparteGroupForm.controls.pais.patchValue(this.currentInternationalClient.nombrePais);
				this.ref.detectChanges();
				this.clienteInternacionalFOrInvoice.emit(this.currentInternationalClient);
				this.setSubheaderClientTitle(this.currentInternationalClient as ClienteInternacional);
				this.facturador.updateClient(this.currentInternationalClient.clienteInternacionalId.toString(), client);
				this.searchingSubelement = false;
				if (result.data.length == 0) {
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Sin datos";
					this.currentSwal.text = "No se han encontrado clientes con el termino: " + this.currentClient.rutString;
					this.currentSwal.fire();
					this.searchingSubelement = false;
				}
			},
			(error) => {
				this.searchingSubelement = false;
				this.prevSearch = undefined;
			}
		);
		this.clientForInvoice.emit(this.currentClient);
		this.facturador.updateClient(this.currentClient.rutString, this.currentClient);
	}

	setClientForm() {
		this.contraparteGroupForm = this.builder.group({
			rutBusqueda: ["", [VerificacionRutValidator]],
			razonSocial: ["", { disabled: true }],
			giro: ["", { disabled: true }],
			dirFact: ["", { disabled: true }],
			comuna: ["", { disabled: true }],
			ciudad: ["", { disabled: true }],
			correoFact: ["", [SingleEmailValidator, Validators.maxLength(100)]],
			pais: ["", { disabled: true }],
		});
	}

	refreshForm(element: any, formGroup: FormGroup) {
		formGroup.patchValue({ razonSocial: "", giro: "", dirFact: "", comuna: "", ciudad: "", correoFact: "", ...element });
	}

	refreshFormValue(name: string, value: any) {
		this.contraparteGroupForm.patchValue({ [name]: value }, { onlySelf: true });
	}

	reset() {
		if (this.isFacturaCompra) {
			this.currentProv = new Proveedor();
			this.contraparteGroupForm.patchValue(this.currentProv);
			this.contraparteGroupForm.get("rutBusqueda")?.patchValue("", { emitEvent: false });
			this.toggleCorreoFactControl();
			return;
		}
		this.currentClient = new Receptor();
		this.receptorOriginal = {};
		this.contraparteGroupForm.patchValue(this.currentClient);
		this.toggleCorreoFactControl();
	}

	private toggleCorreoFactControl(): void {
		const correoControl = this.contraparteGroupForm?.get("correoFact");
		if (!correoControl) return;

		correoControl.enable({ emitEvent: false });
		correoControl.setValidators([SingleEmailValidator, Validators.maxLength(100)]);
		correoControl.updateValueAndValidity({ emitEvent: false });
	}

	inputBlurPlaceholder(event) {} //used in keyup as placeholder for allow the blur in the input with the enter button

	openClientListModal(modalRef) {
		this.resultadosClientes = undefined;
		this.mostrarSelectorClientes(modalRef);
	}

	private mostrarSelectorClientes(modalRef = this.clientListTemplate) {
		this.clientListModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	openProveedorListModal(modalRef) {
		this.proveedorListModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	selectedReceptor(event) {
		this.currentClient = { ...event } as Receptor;
		this.receptorOriginal = { ...this.currentClient };
		this.currentClient = this.currentClient as Receptor;
		this.ref.detectChanges();
		this.refreshForm(this.currentClient, this.contraparteGroupForm);
		this.refreshFormValue("rutBusqueda", this.currentClient.rutString);
		this.contraparteGroupForm.patchValue({
			rutBusqueda: this.currentClient.rutString,
		});
		const correoSeleccionado = this.currentClient.correoFact;
		if (correoSeleccionado !== this.loggedInUserEmail) {
			this.showEmailWarning = true;
		} else {
			this.showEmailWarning = false;
		}
		this.ref.detectChanges();
		this.clientForInvoice.emit(this.currentClient);
		this.setSubheaderClientTitle(this.currentClient as Receptor);
		this.facturador.updateClient(this.currentClient.rutString, this.currentClient);
		this.clientListModal?.close();
	}

	public get puedeCrearOtroCliente(): boolean {
		return !this.isFacturaCompra && !this.isFacturaExportacion && esRutGenerico(this.currentClient.rutString);
	}

	nuevoClienteMismoRut(): void {
		this.selectedReceptor({ receptorId: this.currentClient.receptorId, rutString: this.currentClient.rutString, rut: this.currentClient.rut, dv: this.currentClient.dv } as Receptor);
	}

	async confirmarGuardadoCliente(): Promise<boolean> {
		if (this.isFacturaCompra || this.isFacturaExportacion) return true;
		this.currentClient.guardarCambios = !this.currentClient.clienteId && !this.tieneVersionPropia && !esRutGenerico(this.currentClient.rutString);
		if (cambiaronDatosReceptor(this.receptorOriginal, this.currentClient)) {
			const decision = await Swal.fire({
				title: "Datos del cliente",
				text: "¿Desea conservar estos datos para las próximas emisiones?",
				showDenyButton: true,
				showCancelButton: true,
				confirmButtonText: "Guardar para próximas emisiones",
				denyButtonText: "Solo este documento",
				cancelButtonText: "Volver",
				allowOutsideClick: false,
			});
			if (!decision.isConfirmed && !decision.isDenied) return false;
			this.currentClient.guardarCambios = decision.isConfirmed === true;
		}
		this.clientForInvoice.emit(this.currentClient);
		return true;
	}

	selectedProveedor(event) {
		this.currentProv = { ...event } as Proveedor;
		this.refreshForm(this.currentProv, this.contraparteGroupForm);

		//this.refreshFormValue('rutBusqueda',this.currentProv.rutProveedor);
		//this.contraparteGroupForm.controls.correoFact.enable();
		// this.refreshFormValue('correoFact',this.currentProv.correoPar);
		this.contraparteGroupForm.controls.correoFact.patchValue(this.currentProv.correoFact);
		this.contraparteGroupForm.controls.dirFact.patchValue(this.currentProv.dirFact);
		this.contraparteGroupForm.controls.ciudad.patchValue(this.currentProv.ciudad);
		this.contraparteGroupForm.controls.comuna.patchValue(this.currentProv.comuna);

		this.contraparteGroupForm.patchValue({
			rutBusqueda: this.currentProv.rutProveedor,
		});
		this.ref.detectChanges();
		this.proveedorForInvoice.emit(this.currentProv);
		this.setSubheaderClientTitle(this.currentProv as Proveedor);
		this.facturador.updateProveedor(this.currentProv.rutProveedor, this.currentProv);
		this.proveedorListModalRef.close();
	}

	deactivateValidator(formGroup: FormGroup, controlName: string) {
		formGroup.controls[controlName].clearValidators();
	}

	openInternationalClientListModal(modalRef) {
		this.internationalClientModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	selectedClienteInternacional(event) {
		this.currentInternationalClient = { ...event } as ClienteInternacional;
		this.ref.detectChanges();
		let client: Receptor = new Receptor();
		client.razonSocial = this.currentInternationalClient.razonSocial;
		client.giro = this.currentInternationalClient.giro;
		client.dirFact = this.currentInternationalClient.direccionCalle + " " + this.currentInternationalClient.direccionNumero;
		client.comuna = this.currentInternationalClient.direccionEstadoRegion;
		client.ciudad = this.currentInternationalClient.ciudad;
		client.correoFact = this.currentInternationalClient.correo;
		this.currentInternationalClient.nombrePais = this.PaisesSource.find((pais) => pais.paisId == this.currentInternationalClient.paisId).nombre;
		this.refreshForm(client, this.contraparteGroupForm);
		this.refreshFormValue("rutBusqueda", this.currentInternationalClient.clienteInternacionalId);
		this.refreshFormValue("razonSocial", client.razonSocial);
		this.refreshFormValue("giro", client.giro);
		this.refreshFormValue("dirFact", client.dirFact);
		this.refreshFormValue("comuna", client.comuna);
		this.refreshFormValue("ciudad", client.ciudad);
		this.refreshFormValue("correoFact", client.correoFact);
		this.refreshFormValue("pais", this.currentInternationalClient.nombrePais);
		this.contraparteGroupForm.controls.pais.patchValue(this.currentInternationalClient.nombrePais);
		this.ref.detectChanges();
		this.clienteInternacionalFOrInvoice.emit(this.currentInternationalClient);
		this.setSubheaderClientTitle(this.currentInternationalClient as ClienteInternacional);
		this.facturador.updateClient(this.currentInternationalClient.clienteInternacionalId.toString(), client);
		this.internationalClientModalRef.close();
	}

	getPais(client: ClienteInternacional) {
		client.nombrePais = this.PaisesSource.find((pais) => pais.paisId == client.paisId).nombre;
	}

	setSubheaderClientTitle(receptor) {
		let titleMessage = "";
		// if (receptor.rutString) {
		//    titleMessage = "Cliente: " + receptor.razonSocial + "  Rut: " + receptor.rutString;
		// }
		// if (receptor.rutProveedor) {
		//    titleMessage = "Proveedor: " + receptor.razonSocial + "  Rut: " + receptor.rutProveedor;
		// }
		// if (receptor.nombrePais) {
		//    titleMessage = "Cliente: " + receptor.razonSocial + "  Pais: " + receptor.nombrePais;
		// }
		this.subheader.setTitle(titleMessage);
	}

	changeCorreoFact(correo: string): void {
		if (correo !== this.loggedInUserEmail) {
			this.showEmailWarning = true;
		} else {
			this.showEmailWarning = false;
		}

		if (this.isFacturaCompra) {
			this.currentProv.correoFact = correo;
			this.currentProv.correoPar = correo;
			this.proveedorForInvoice.emit(this.currentProv);
		} else {
			this.currentClient.correoFact = correo;
			this.clientForInvoice.emit(this.currentClient);
		}
	}
	changeDireccion(direccion) {
		if (this.isFacturaCompra) {
			this.currentProv.dirFact = direccion;
			this.proveedorForInvoice.emit(this.currentProv);
		} else {
			this.currentClient.dirFact = direccion;
			this.clientForInvoice.emit(this.currentClient);
		}
	}

	changeCiudad(ciudad) {
		if (this.isFacturaCompra) {
			this.currentProv.ciudad = ciudad;
			this.proveedorForInvoice.emit(this.currentProv);
		} else {
			this.currentClient.ciudad = ciudad;
			this.clientForInvoice.emit(this.currentClient);
		}
	}

	changeRazonSocial(razonSocial) {
		if (this.isFacturaCompra) {
			this.currentProv.razonSocial = razonSocial;
			this.proveedorForInvoice.emit(this.currentProv);
		} else {
			this.currentClient.razonSocial = razonSocial;
			this.clientForInvoice.emit(this.currentClient);
		}
	}

	changeComuna(comuna) {
		if (this.isFacturaCompra) {
			this.currentProv.comuna = comuna;
			this.proveedorForInvoice.emit(this.currentProv);
		} else {
			this.currentClient.comuna = comuna;
			this.clientForInvoice.emit(this.currentClient);
		}
	}
	changeGiro(giro) {
		if (this.isFacturaCompra) {
			this.currentProv.giro = giro;
			this.proveedorForInvoice.emit(this.currentProv);
		} else {
			this.currentClient.giro = giro;
			this.clientForInvoice.emit(this.currentClient);
		}
	}

	changePais(pais: string) {
		if (this.isFacturaExportacion && this.currentInternationalClient) {
			this.currentInternationalClient.nombrePais = pais;
			let client: Receptor = new Receptor();
			client.razonSocial = this.currentInternationalClient.razonSocial;
			client.giro = this.currentInternationalClient.giro;
			client.dirFact = this.currentInternationalClient.direccionCalle + " " + this.currentInternationalClient.direccionNumero;
			client.comuna = this.currentInternationalClient.direccionEstadoRegion;
			client.ciudad = this.currentInternationalClient.ciudad;
			client.correoFact = this.currentInternationalClient.correo;
			client.rutString = this.currentInternationalClient.clienteInternacionalId.toString();
			const paisEncontrado = this.PaisesSource.find((p) => p.nombre === pais);
			if (paisEncontrado) {
				this.currentInternationalClient.paisId = paisEncontrado.paisId;
				this.currentInternationalClient.codigoPais = paisEncontrado.codigoSii;
			}
			this.clienteInternacionalFOrInvoice.emit(this.currentInternationalClient);
			this.clientForInvoice.emit(client);
			this.facturador.updateClient(this.currentInternationalClient.clienteInternacionalId.toString(), client);
		}
	}

}
